import { t } from 'i18next';
import { Text } from '@mantine/core';
import { Column, Staff } from 'utils/models';

export const StaffColumns = (): Column<Staff>[] => {
  const columns: Column<Staff>[] = [
    {
      header: t('name_label'),
      width: 25,
      renderItem: (item) => <Text>{`${item.firstName} ${item.lastName}`}</Text>,
    },
    {
      header: t('email_label'),
      width: 25,
      renderItem: (item) => <Text>{item.email}</Text>,
    },
    {
      header: t('phone_label'),
      width: 25,
      renderItem: (item) => <Text>{item.phoneNumber}</Text>,
    },
  ];
  return columns;
};
